import { render, staticRenderFns } from "./inspectCountscoreInfo.vue?vue&type=template&id=1610daa4&scoped=true&"
import script from "./inspectCountscoreInfo.vue?vue&type=script&lang=js&"
export * from "./inspectCountscoreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610daa4",
  null
  
)

export default component.exports